import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="text-primary-neon text-xl">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (requiredRole) {
    // superadmin can access admin routes
    if (requiredRole === 'admin' && (user.role === 'admin' || user.role === 'superadmin')) {
      return children;
    }
    if (user.role !== requiredRole) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
}